import React, { Suspense, useState, useEffect, useRef } from "react";
import systemListingService from "./SystemListingServices";
import StatementStatusUpsert from "./upsert/StatementStatusUpsert ";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function StatementStatus(param: any) {

  let [deleteData, setDeleteData] = useState<any>([]);
  let [deleteStatus, setDeleteStatus] = useState(false);
  let [editingOn, setEditingOn] = useState(false);
  let [openUpsertUX, setOpenUpsertUX] = useState(false);
  let [editDataDawer, seteditDataDawer] = useState<any>([]);
  let [StatementStatus, SetStatementStatus] = useState<any>([]);

  useEffect(() => {
    if (param.activeTab === "Statement Status") {
      StatementStatusSelect()
    }
  }, [param]);

  const StatementStatusSelect = () => {
    var payload = {}
    systemListingService.statusStatementList(payload).then((res: any) => { SetStatementStatus(res) });
  }

  const openAddDrawer = (e: any) => {
    editDataDawer = e
    seteditDataDawer(editDataDawer)
    openUpsertUX = true
    setOpenUpsertUX(openUpsertUX)
  };

  const closeUpsertUX = () => { setOpenUpsertUX(!openUpsertUX) }

  const deleteSelection = (e: any) => {
    console.log(e)
    deleteData = e
    setDeleteData(deleteData)

    deleteStatus = true;
    setDeleteStatus(deleteStatus)
  }

  const deleteConfirmation = (e: any) => {
    console.log(e)

    //e==1 YES
    if (e == 1) {
      systemFormatsList.deletestatusStatement(deleteData).then((respond: any) => {
        CommonUtilities.showToastDawer('Statement Status delete Successfull', 'Success')
      })
    }
    //e==2 NO
    deleteStatus = false;
    setDeleteStatus(deleteStatus)
  }

  const slider_handler = (e: any, selectData: any) => {

    if (e.target.type == "checkbox") {

      selectData[e?.target?.name] = selectData[e?.target?.name] == 1 ? 0 : 1

      systemListingService.saveStatusStatement(selectData).then((repond: any) => {
        StatementStatusSelect();
      })
    }
  }

  return (
    <div className="content-card ws-12">
      {/* Edit tab */}
      <div className="ptl pbl ws-12">
        <span className="text-bold">Statement Status</span>
        <button className="icon-btn info pull-right" type="button" onClick={() => setEditingOn((prev) => !prev)}>{editingOn ? "Edit Mode: On" : "Edit Mode: Off"}</button>

        <div className="ws-12 mt">
          <button className="icon-btn primary height35 pull-right fill" type="button" onClick={() => openAddDrawer({})} disabled={!editingOn}>Add Statement Status</button>
          <button className="btn-save-table hide" type="button" disabled={!editingOn} onClick={() => { setEditingOn(false); }}>Save Changes</button>
        </div>

      </div>

      {/* Table */}
      <div className="ws-12 allowHscroll allowVscroll">
        <table className={editingOn ? "editing-on newTable" : " newTable"}>
          <thead>
            <tr>
              <th className="forceSingleLine">Status ID</th>
              <th className="forceSingleLine">Status Name</th>
              <th className="forceSingleLine">Status Code</th>
              <th className="forceSingleLine">Rec MYN</th>
              <th className="forceSingleLine">Publ YN</th>
              <th className="forceSingleLine">Mech YN</th>
              <th className="forceSingleLine">Approval YN</th>
              <th className="forceSingleLine">Control Rpt YN</th>
              <th className="forceSingleLine">Email YN</th>
              <th className="forceSingleLine">Auto LTD</th>
              <th style={{ width: "19%" }}>
                Operations
              </th>
            </tr>
          </thead>
          <tbody>
            {StatementStatus.map((row: any) => (
              <tr key={row.id}>
                <td>{row.statementStatusUseID}</td>
                <td>
                  <span style={{
                    background: CommonUtilities.lookUpTypeList('statementStatusName', row.statementStatusName, 'bgColor'),
                    color: CommonUtilities.lookUpTypeList('statementStatusName', row.statementStatusName, 'fontColor'),
                    borderRadius: "4px"
                  }} className="pm forceSingleLine">
                    {row.statementStatusName}
                  </span>

                </td>
                <td>{row.statementStatusShortCode}</td>
                <td>

                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="recMYN" checked={row?.recMYN === 1} onChange={(e: any) => slider_handler(e, row)} />
                    {row?.recMYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.recMYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td>
                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="publYN" checked={row?.publYN === 1} onChange={(e: any) => slider_handler(e, row)} />
                    {row?.publYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.publYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td>

                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="mechYN" checked={row?.mechYN === 1} onChange={(e: any) => slider_handler(e, row)} />
                    {row?.mechYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.mechYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td>


                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="approvalYN" checked={row?.approvalYN === 1} onChange={(e: any) => slider_handler(e, row)} />
                    {row?.approvalYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.approvalYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td>
                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="controlRptYN" checked={row?.controlRptYN === 1} onChange={(e: any) => slider_handler(e, row)} />
                    {row?.controlRptYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.controlRptYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td>
                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="emailYN" checked={row?.emailYN === 1} onChange={(e: any) => slider_handler(e, row)} />
                    {row?.emailYN === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.emailYN === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td>
                  <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                    <input type="checkbox" name="autoLTD" checked={row?.autoLTD === 1} onChange={(e: any) => slider_handler(e, row)} />
                    {row?.autoLTD === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                    {row?.autoLTD === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                  </label>
                </td>

                <td style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }}>

                  <div className="width225">
                    <button className={`icon-btn info ${row.isDefault ? "fill" : ""}`} type="button" disabled={!editingOn}>Default</button>
                    <button className="icon-btn edit" title="Edit " type="button" onClick={() => openAddDrawer(row)} disabled={!editingOn}><i className="icon-pencil"></i> </button>
                    <button className="icon-btn delete" type="button" disabled={!editingOn} onClick={() => deleteSelection(row)}><i className="icon-trash"> </i></button>
                  </div>

                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {
        (() => {
          if (openUpsertUX) {
            return <StatementStatusUpsert openUpsertUX={openUpsertUX} closeDrawer={closeUpsertUX} />
          }

          if (deleteStatus) {
            return <DeleteDialogueBox param={deleteStatus} message={"delete the selected statement status " + deleteData?.statementStatusName} onChange={deleteConfirmation} />
          }
        })()
      }
    </div>
  );
};